import { createContext } from 'react';

export interface LocaleProps {
  value: 'en' | 'id' | 'fr' | 'de' | 'ja' | 'zh';
  change: (lang: 'en' | 'id' | 'fr' | 'de' | 'ja' | 'zh') => void;
}

const LanguageContext = createContext<LocaleProps>({
  value: 'en',
  change: lang => { },
});

export default LanguageContext;
